/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {PontoListComponent} from "./ponto-list/ponto-list.component";
import {PontoFormComponent} from "./ponto-form/ponto-form.component";
import {editRoute, newRoute, configuracaoRoute} from "../../shared/services/data.service";
import {viagensRoute} from "../shared/data.service";
import {pontosRoute} from "./shared/data.service";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class PontosRoutingModule {}

export const pontosRoutes: any[] = [
    {
        path: '',
        component: PontoListComponent,
        data: {
            breadcrumb: viagensRoute + '/' + configuracaoRoute + '/' + pontosRoute
        }
    },{
        path: editRoute + '/:id',
        component: PontoFormComponent
    },{
        path: newRoute,
        component: PontoFormComponent
    }

];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/pontos/pontos-routing.module.ts
 **/